<template>
  <div>
    <v-card>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">Ristampa Seriale</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
              <v-icon color="error"> {{ close_icon }} </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-container class="mt-1" fluid v-if="filtri_visible">
        <v-row dense>
          <v-col cols="3">
            <v-menu
              ref="menu"
              v-model="menu_data"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="289"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  hide-details
                  label="Data"
                  prepend-icon="mdi-calendar"
                  v-model="data_formattata"
                  v-on="on"
                  readonly
                >
                  <template slot="append">
                    <v-icon
                      @click="data_filtro = ''"
                      color="primary"
                      v-if="data_filtro != ''"
                    >
                      mdi-filter-off
                    </v-icon>
                  </template></v-text-field
                >
              </template>
              <v-date-picker v-model="data_filtro" @input="menu_data = false">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3">
            <v-text-field
              dense
              hide-details
              label="Seriale"
              v-model="filtro_seriale"
              @keyup.enter="getCommessaAvanzamento"
            >
            </v-text-field>
          </v-col>
          <v-col align="left" cols="3">
            <v-btn @click="getCommessaAvanzamento" small>
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
      </v-container>
      <v-card-text class="mt-0 pt-0">
        <v-container fluid>
          <v-row dense>
            <v-col cols="12">
              <v-data-table
                :headers="headers_registrazioni"
                :items="items_registrazioni"
                height="70vh"
                fixed-header
              >
                <template v-slot:[`item.selezione`]="{ item }">
                  <v-btn @click="selezionaRegistrazione(item)" small>
                    <v-icon color="success">mdi-check</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <!-- Dialog della visualizzazione dei seriali -->
      <v-dialog v-model="dialog_report_seriali" width="60vw" persistent>
        <StampaReportSeriali
          @chiudi="dialog_report_seriali = false"
          :seriali="items_seriali"
          :visible="dialog_report_seriali"
          :workorder="workorder_sel"
        />
      </v-dialog>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />

      <!-- Loader -->
      <v-overlay :value="caricamento_dati">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import StampaReportSeriali from "@/components/PRODUCTION/ProduzioneInsit/StampaReportSeriali.vue";

export default {
  name: "",
  components: { StampaReportSeriali, SnackbarQV },
  props: {
    close_icon: {
      type: String,
      default: "mdi-close",
    },
    filtri_visible: {
      type: Boolean,
      default: false,
    },
    workorder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      data_filtro: "",
      filtro_seriale: null,
      workorder_sel: new Object(),

      // Modal
      caricamento_dati: false,
      dialog_report_seriali: false,
      menu_data: false,

      // Array
      headers_registrazioni: [
        {
          text: "Selezione",
          value: "selezione",
          sortable: false,
        },
        {
          text: "Cod. Commessa",
          value: "cod_commessa",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des. Fase",
          value: "des_fase",
          sortable: false,
        },
        {
          text: "Cod. Fase",
          value: "cod_fase",
          sortable: false,
        },
        {
          text: "Seriale",
          value: "cod_lotto_prodotto",
          sortable: false,
        },
        {
          text: "Nominativo",
          value: "nominativo",
          sortable: false,
        },
        {
          text: "Data",
          value: "_ora",
          sortable: false,
        },
      ],
      items_registrazioni: new Array(),
      items_seriali: new Array(),
    };
  },
  computed: {
    data_formattata() {
      return this.data_filtro != ""
        ? moment(this.data_filtro).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    data_formattata: {
      immediate: true,
      handler() {
        if (
          this.data_formattata !== null &&
          this.data_formattata !== undefined &&
          this.data_formattata !== ""
        ) {
          this.getCommessaAvanzamento();
        }
      },
    },
    workorder: {
      immediate: true,
      handler() {
        if (this.workorder && this.workorder.id_commessa) {
          this.workorder_sel = JSON.parse(JSON.stringify(this.workorder));
          this.getCommessaAvanzamento();

        }
      },
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("chiudi");
    },
    getCommessaAvanzamento() {
      // Controllo di avere i campi necessari per preparare una request.
      let campi_wo = true;

      if (this.workorder_sel) {
        if (
          this.workorder_sel.id_commessa === null ||
          this.workorder_sel.id_commessa === undefined ||
          this.workorder_sel.id_commessa === "" ||
          this.workorder_sel.id_commessa_dettaglio === null ||
          this.workorder_sel.id_commessa_dettaglio === undefined ||
          this.workorder_sel.id_commessa_dettaglio === ""
        ) {
          campi_wo = false;
        }
      } else {
        campi_wo = false;
      }

      let campi_filtri = true;

      if (
        (this.data_filtro === null ||
          this.data_filtro === undefined ||
          this.data_filtro === "") &&
        (this.filtro_seriale === null ||
          this.filtro_seriale === undefined ||
          this.filtro_seriale === "") &&
        campi_wo === false
      ) {
        campi_filtri = false;
      }

      // Se non ho né filtri né WO, non posso preparare la request.
      if (campi_filtri === false && campi_wo === false) {
        this.$refs.SnackbarQV.print("orange", "Inserire i dati di filtro.");
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaavanzamento",
          token: localStorage.getItem("user_token"),
          tipo: "p",
          analisi: "prod",
          id_commessa: this.workorder_sel
            ? this.workorder_sel.id_commessa
            : null,
          id_commessa_dettaglio: this.workorder_sel
            ? this.workorder_sel.id_commessa_dettaglio
            : null,
          data_da: this.data_filtro,
          data_a: this.data_filtro,
          cod_lotto_prodotto: this.filtro_seriale,
        },
      };

      // Elimino gli eventuali campi inutili.
      if (
        this.data_filtro === null ||
        this.data_filtro === undefined ||
        this.data_filtro === ""
      ) {
        delete request.richiesta.data_da;
        delete request.richiesta.data_a;
      }

      if (
        request.richiesta.cod_lotto_prodotto === null ||
        request.richiesta.cod_lotto_prodotto === undefined ||
        request.richiesta.cod_lotto_prodotto === ""
      ) {
        delete request.richiesta.cod_lotto_prodotto;
      }

      if (
        request.richiesta.id_commessa === null ||
        request.richiesta.id_commessa === undefined ||
        request.richiesta.id_commessa === ""
      ) {
        delete request.richiesta.id_commessa;
      }

      if (
        request.richiesta.id_commessa_dettaglio === null ||
        request.richiesta.id_commessa_dettaglio === undefined ||
        request.richiesta.id_commessa_dettaglio === ""
      ) {
        delete request.richiesta.id_commessa_dettaglio;
      }

      this.caricamento_dati = true;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_registrazioni = [];
            this.items_registrazioni = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          this.caricamento_dati = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    selezionaRegistrazione(arg) {
      this.items_seriali = new Array();
      this.items_seriali.push({
        id: arg.id_magazzino_movimenti,
      });
      this.workorder_sel = {
        id_articolo_packaging: arg.id_articolo_packaging,
        id_magazzino_movimenti: arg.id_magazzino_movimenti,
        cod_macchina: arg.cod_macchina,
        cod_articolo: arg.cod_articolo,
        quantita: arg.quantita,
        cod_articolo_packaging: arg.cod_articolo_packaging,
        id_utente: arg.id_personale,
      };
      this.dialog_report_seriali = true;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>